import { render, staticRenderFns } from "./social-club-editable-comment.vue?vue&type=template&id=1787f0f6&scoped=true&lang=pug"
import script from "./social-club-editable-comment.js?vue&type=script&lang=js&external"
export * from "./social-club-editable-comment.js?vue&type=script&lang=js&external"
import style0 from "./social-club-editable-comment.vue?vue&type=style&index=0&id=1787f0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787f0f6",
  null
  
)

export default component.exports